import { GetServerSideProps } from "next";
import { ReactElement } from "react";
import IForkLiftWrapper from "@components/layouts/iForkLiftWrapper";

import { getPageProps } from "@services/initial-calls";
import PrivacyPolicy from "@components/shared/legal/privacyPolicy";

export default function FreeCreditEvaluationHome(): ReactElement {
    return (
        <IForkLiftWrapper>
            <PrivacyPolicy category="Forklifts" domain="iForklift.com" />
        </IForkLiftWrapper>
    );
}

export const getServerSideProps: GetServerSideProps = async (context) => {
    return await getPageProps(context, "home", { pageTitle: "Privacy Policy" });
};
